import React from "react";
import PageTitle from "../components/PageTitle";
import ScheduleSection from "../Schedule";
import ImageWithText from "./ImageWithText";
import PageCarousel from "./PageCarousels";

const Instantcash = () => {
  PageTitle(
    "Instant Cash - Right Cash - We Buy, We Sell, Buybacks, Pawnbrokers. Get Cash Fast - Chatham, Kent - Pawn Shop"
  );
  return (
    <div>
      <div class="page-header">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2>SELL YOUR GOODS</h2>
            </div>
            <div class="col-12">
              <a href="">Home</a>
              <a href="">Instant Cash</a>
            </div>
          </div>
        </div>
      </div>
      <PageCarousel collectionName="instantcash_banner" />
      <div class="about wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-5 col-md-6">
              <div class="about-img">
                <img src="img/instantcash1.png" alt="Image" />
              </div>
            </div>
            <div class="col-lg-7 col-md-6">
              <div class="section-header text-left">
                {/* <p>Welcome to RightCash</p> */}
                <h2>SELL YOUR GOODS</h2>
              </div>
              <div class="about-text">
                <p>
                  Sometimes a bit of cash can always come in handy. Maybe you’re
                  saving for a holiday, or perhaps you just want a bit of extra
                  spending money, or an unforeseen expense crops up. Whatever
                  your needs – Right Cash can help you get instant cash for your
                  items.
                </p>
                <h3>
                  <p>What do you need to do?</p>
                </h3>
                <p>
                  Simply tap the WhatsApp button below for a free quote or drop
                  by the store with your item. We’ll check it out and give you a
                  free quote. If you’re happy with the price, just show us some
                  ID to complete the deal, and you’ll walk away with INSTANT
                  CASH - right then and there!
                </p>
                <a href="/buybacks">
                  <h3>
                    <p>
                      (If you don’t want to sell your items forever – try our
                      buyback service. Click here for more details.)
                    </p>
                  </h3>
                </a>
                <h3>
                  <p>What kinds of items do we take?</p>
                </h3>
                <p>We will consider any item of value! For example:</p>
                <ul>
                  <li>Gold and silver</li>
                  <li>Jewellery</li>
                  <li>Watches</li>
                  <li>Mobile phones and tablets</li>
                  <li>TVs</li>
                  <li>Laptops</li>
                  <li>Sat navs</li>
                  <li>Musical instruments</li>
                  <li>Cameras</li>
                  <li>Audio Equiptment</li>
                  <li>And much more besides!</li>
                </ul>
                <a
                  class="btn"
                  href="https://api.whatsapp.com/send?phone=447871092759"
                >
                  GET A FREE QUOTE NOW{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <ScheduleSection />
    </div>
  );
};

export default Instantcash;
